import { render, staticRenderFns } from "./validation-field-lable.vue?vue&type=template&id=2b37dff6&functional=true&"
import script from "./validation-field-lable.vue?vue&type=script&lang=ts&"
export * from "./validation-field-lable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports